import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M107.98 41.87C107.98 41.87 80.3505 27.42 78.9505 25.66C77.5505 23.9 76.6105 1 76.6105 1H54.6005C54.6005 1 53.6605 23.9 52.2605 25.66C50.8605 27.42 23.2305 41.87 23.2305 41.87C23.2305 41.87 35.4805 56.92 65.6105 56.92C95.7405 56.92 107.98 41.87 107.98 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M121.7 47.57C118.62 43.94 84.06 26.76 84.06 26.76L65.61 47.39L47.16 26.76C47.16 26.76 12.6 43.93 9.52 47.57C6.44 51.2 2 72.72 2 72.72H129.23C129.22 72.72 124.78 51.2 121.7 47.57Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M40.2803 30.99L65.6303 59.28L90.9303 30.99"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6054"
          y1="35.3978"
          x2="65.6054"
          y2="24.9024"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
